export default "__VITE_ASSET__d1ef201c__"